package com.appsyde.shared.modules.account.data.source

import com.appsyde.shared.modules.account.data.AccountResponseDto
import com.appsyde.shared.modules.account.data.BillingStatusDto
import com.appsyde.shared.modules.account.data.CheckoutSessionResponseDto
import com.appsyde.shared.modules.account.data.CustomerPortalResponseDto
import com.appsyde.shared.modules.account.data.MeResponseDto
import com.appsyde.shared.modules.account.data.SignatureUpdateResponseDto

/** Résultat de la demande d'envoi d'email de confirmation de suppression. */
sealed class RequestDeletionResultDto {
    data object Ok : RequestDeletionResultDto()
    data object AlreadyPending : RequestDeletionResultDto()
    data class Error(val message: String?) : RequestDeletionResultDto()
}

interface AccountRemoteDataSource {
    suspend fun getMe(): MeResponseDto?
    suspend fun getAccount(): AccountResponseDto?
    suspend fun updateTone(tone: String): String?
    suspend fun updateSignature(signatureEnabled: Boolean, signatureValue: String): SignatureUpdateResponseDto?
    suspend fun requestAccountDeletion(): RequestDeletionResultDto
    suspend fun completeOnboarding(): Boolean
    suspend fun getBillingStatus(): BillingStatusDto?
    suspend fun createCheckoutSession(): CheckoutSessionResponseDto?
    suspend fun createCustomerPortalSession(): CustomerPortalResponseDto?
}
